import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en/translation.json';
import ar from './ar/translation.json';
import { DEFAULT_LANGUAGE } from '@/config';
import useLanguageStore from '@/stores/useLanguageStore';

// R54 (CA.1) — boot in the language the merchant actually chose.
//
// This used to init at DEFAULT_LANGUAGE ('en') and let an effect in index.tsx
// correct it after mount, so every full mount painted English before flipping
// to Arabic. `useLanguageStore` persists to localStorage and zustand rehydrates
// that synchronously at store creation, so the saved language is already
// available here — one render earlier than the effect. The effect stays: it is
// what handles the merchant CHANGING language mid-session.
const initialLanguage = useLanguageStore.getState().language || DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
